import React from "react";
import { cn } from "./cn";

export default function LoadingState({ label = "Cargando...", className }) {
  return (
    <div className={cn("flex min-h-[35vh] flex-col items-center justify-center gap-3", className)}>
      <div className="h-12 w-12 rounded-full border-2 border-arena/20 border-t-gold animate-spin" aria-hidden />
      <p className="text-sm font-semibold text-ink-muted">{label}</p>
    </div>
  );
}
